export default {
	events: {
		'ddc.form.confirmation': {
			logic: {
				mustExist: '[[mapping.form.confirm.[[eventData.trackingId]]]]'
			},
			payload: {
				event: '[[mapping.form.confirm.[[eventData.trackingId]]]]'
			}
		},
		'ddc.form.initiation': {
			logic: {
				mustExist: '[[mapping.form.init.[[eventData.trackingId]]]]'
			},
			payload: {
				event: '[[mapping.form.init.[[eventData.trackingId]]]]'
			}
		},
		'ddc.form.paymentCalcInit': {
			payload: {
				shared: ['[[mapping.configuration.sharedPayloads.paymentCalc]]']
			}
		},
		'ddc.inventory.filterSearch': {
			payload: {
				event: 'mmna-t3-tagging-trackInventoryResults',
				'mmna-t3-tagging': {
					inventoryFilterKvp: '[[eventData.queryFacets]]'
				}
			}
		},
		'ddc.link.clickToCall': {
			payload: {
				event: 'mmna-t3-tagging-trackClickToCall',
				'mmna-t3-tagging': {
					clickToCallPhone: '[[eventData.phoneNumber]]',
					clickToCallDepartment: '[[eventData.clickToCallDepartment]]'
				}
			}
		},
		'ddc.link.generic': [
			{
				logic: {
					widgetName: 'ws-inv-facets'
				}
			},
			{
				logic: {
					widgetName: 'recommendations-vehicles'
				}
			},
			{
				logic: ({ eventData }) =>
					(
						eventData?.url || eventData?.attributes?.['data-src']
					)?.includes('rs/file/monroney') ||
					(
						eventData?.url || eventData?.attributes?.['data-src']
					)?.includes('/windowsticker/mitsubishi'),
				payload: {
					event: 'mmna-t3-tagging-trackBrochureDownload',
					'mmna-t3-tagging': {
						brochureId: ({ eventData }) =>
							eventData.url || eventData?.attributes['data-src']
					}
				}
			},
			{
				logic: {
					trackingLabel: 'lead form print link'
				},
				payload: {
					event: 'mmna-t3-tagging-trackOfferDownload',
					'mmna-t3-tagging': {
						offerId: '[[eventData.id]]'
					}
				}
			},
			{
				logic: {
					location: 'content'
				},
				payload: {
					event: 'mmna-t3-tagging-trackLinkClick',
					'mmna-t3-tagging': {
						linkText: '[[eventData.text]]',
						linkUrl: '[[eventData.url]]'
					}
				}
			}
		],
		'ddc.link.navClick': [
			{
				logic: {
					position: 'bottomNav'
				},
				payload: {
					event: 'mmna-t3-tagging-trackNavigation',
					'mmna-t3-tagging': {
						linkText: '[[eventData.linkText]]',
						linkUrl: '[[eventData.url]]'
					}
				}
			},
			{
				logic: {
					isChildLink: true
				},
				payload: {
					event: 'mmna-t3-tagging-trackNavigation',
					'mmna-t3-tagging': {
						linkText:
							'[[eventData.menuLinkText]] | [[eventData.linkText]]',
						linkUrl: '[[eventData.url]]'
					}
				}
			}
		],
		'ddc.link.recommendedVehicle': {
			payload: {
				event: 'mmna-t3-tagging-trackLinkClick',
				'mmna-t3-tagging': {
					linkText: '[[eventData.text]]',
					linkUrl: '[[eventData.url]]'
				}
			}
		},
		'ddc.page.view': [
			{
				logic: {
					mustExist:
						'[[DDC.dataLayer.page.trackingTags.pagecategory]]'
				},
				payload: {
					event: 'mmna-t3-tagging-trackPageLoad',
					'mmna-t3-tagging': {
						dealerAddress: '[[address1]] [[address2]]',
						dealerCity: '[[city]]',
						dealerName: '[[dealershipName]]',
						dealerState: '[[stateProvince]]',
						dealerZipCode: '[[postalCode]]',
						pageCategory:
							'[[DDC.dataLayer.page.trackingTags.pagecategory]]',
						siteProvider: 'DDC',
						siteDomain: '[[website]]',
						vehicleModel: '[[model]]',
						vehiclePrice: '[[internetPrice]]',
						vehicleTrim: '[[trim]]',
						vehicleYear: '[[year]]'
					}
				}
			},
			{
				payload: {
					event: 'mmna-t3-tagging-trackPageLoad',
					'mmna-t3-tagging': {
						dealerAddress: '[[address1]] [[address2]]',
						dealerCity: '[[city]]',
						dealerName: '[[dealershipName]]',
						dealerState: '[[stateProvince]]',
						dealerZipCode: '[[postalCode]]',
						pageCategory:
							'[[DDC.dataLayer.page.trackingTags.pagecategory]] >> [[DDC.dataLayer.page.trackingTags.pageType]] >> [[mapping.pagealias.pageType]]',
						siteProvider: 'DDC',
						siteDomain: '[[website]]',
						vehicleModel: '[[model]]',
						vehiclePrice: '[[internetPrice]]',
						vehicleTrim: '[[trim]]',
						vehicleYear: '[[year]]'
					}
				}
			}
		],
		'ddc.video.milestone': {
			logic: {
				mustExist: '[[eventData.videoMilestone]]',
				videoMilestone: 'complete'
			},
			payload: {
				event: 'mmna-t3-tagging-trackVideoCompleted',
				'mmna-t3-tagging': {
					videoId: '[[eventData.videoSource]]'
				}
			}
		},
		'ddc.video.play': {
			logic: {
				mustNotInclude: {
					'eventData.autoplay': true
				}
			},
			payload: {
				event: 'mmna-t3-tagging-trackVideoPlay',
				'mmna-t3-tagging': {
					videoId: '[[eventData.videoSource]]'
				}
			}
		},
		widgetUserEvent: [
			{
				logic: {
					eventName: 'DR_PAYMENT_DISPLAY'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.paymentCalc]]'
					]
				}
			},
			{
				logic: {
					widgetName: 'ws-inv-filters',
					element: 'Sort'
				},
				payload: {
					event: 'mmna-t3-tagging-trackInventoryResults',
					'mmna-t3-tagging': {
						inventoryFilterKvp: '[[queryFacets]]'
					}
				}
			},
			{
				logic: {
					isWindowStickerLink: true
				},
				payload: {
					event: 'mmna-t3-tagging-trackBrochureDownload',
					'mmna-t3-tagging': {
						brochureId: ({ eventData }) =>
							eventData.url ||
							eventData?.attributes?.['data-src'] ||
							''
					}
				}
			}
		]
	}
};
